import React from "react";
import Management from "components/general/Management";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";

const UniversityMajors = () => {
    const navigate = useNavigate();

    const layout = [
        [{ label: "Mã ngành học", name: "code", type: "input", rules: [{ required: true }] }],
        [{ label: "Tên ngành học", name: "name", type: "input", rules: [{ required: true }] }],
        [{ label: "Mô tả ngành học", name: "description", type: "textarea", rules: [{ required: true }] }],
        [{ label: "Logo ngành", name: "logo", type: "upload" }],
        [{ label: "Tổng số tín chỉ", name: "credit", type: "number", rules: [{ required: true, type: "inputNumber", min: 0 }] }],
    ];
    return (
        <div>
            <h2>Quản Lý Ngành Học</h2>
            <Management
                layout={layout}
                apiPath="/majors/"
                itemName="ngành học"
                listMode="card"
                useFrontendPagination={false}
                disableSearch={false}
                excelImportExportOptions={{
                    apiPath: "/majors/",
                    itemName: "ngành học",
                    exportFields: ["name", "description", "credit"],
                    expectedCsvType: "majors",
                }}
                onCardClick={(item) => navigate(`/university-majors/${item.id}`)}
                onSubmitError={(error) => {
                if (
                    error?.response?.status === 400 && error?.response?.data?.non_field_errors
                    && error?.response?.data?.non_field_errors[0] === "The fields university, code must make a unique set."
                ) {
                    toastr.error("Mã ngành học đã tồn tại");
                }
                }}
            />
        </div>
    );
};

export default UniversityMajors;
